import FinancialTabs from "common/FinancialTabs";
import { getInfo } from "services/FinancialDepartment";
import { useEffect, useState } from "react";
export default function FinancialReportTab({ userId }) {
  const [financialInformation, setFinancialInformation] = useState();
  const [updaterFlag, setUpdaterFlag] = useState(false);
  const [transactionList1, setTransactionList1] = useState([]);
  const [transactionList2, setTransactionList2] = useState([]);
  const [transactionList3, setTransactionList3] = useState([]);
  const [transactionListAll, setTransactionListAll] = useState([]);
  console.log("financialInformation", financialInformation);
  function updater() {
    setUpdaterFlag(!updaterFlag);
  }
  useEffect(() => {
    setTransactionList1([]);
    setTransactionList2([]);
    setTransactionList3([]);

    getInfo(userId).then((value) => {
      setFinancialInformation(true);
      if (!value) {
        value = { transactionList: [] };
      }
      for (let index = 0; index < value.transactionList.length; index++) {
        setTransactionListAll((prev) => [...prev, value.transactionList[index]]);

        switch (value.transactionList[index].type) {
          case "1":
            setTransactionList1((prev) => [...prev, value.transactionList[index]]);
            break;
          case "2":
            setTransactionList2((prev) => [...prev, value.transactionList[index]]);
            break;
          case "3":
            setTransactionList3((prev) => [...prev, value.transactionList[index]]);
            break;
          default:
            break;
        }
      }
    });
  }, [updaterFlag]);

  return (
    <div class="tab-pane fade" id="financial-report">
      {financialInformation && <FinancialTabs transactionList1={transactionList1} transactionList2={transactionList2} transactionList3={transactionList3} updater={updater} userList={[]} transactionListAll={transactionListAll} isReadOnly={true}></FinancialTabs>}
    </div>
  );
}
